<template>
  <div>
    <!--main Start!-->
    <div id="main" class="wp clearfix" v-loading="loading">
      <el-row>
        <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="leftMenu fl">
            <dl style="padding-right: 20px">
              <dt>
                <span>
                  <h4>{{ DepsData.name }}</h4>
                  <h5>{{ DepsData.english }}</h5>
                </span>
              </dt>
              <dd
                :class="{ on: newClassId == item.cid }"
                v-for="(item, cindex) in DepsData.children"
                :key="cindex"
              >
                <a @click="gotonav(item, cindex)" v-if="item.cid != 1007">{{
                  item.name
                }}</a>
              </dd>
            </dl>
          </div>
        </el-col>
        <el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
          <div class="rightCon fr">
            <div class="conTop clearfix">
              <div class="crumbs">
                <a @click.prevent="gotoindex">首页</a>
                <i>-</i>
                <span>{{ spanTitle }}</span>
              </div>
              <div class="conTit clearfix">
                <span>{{ spanTitle }}</span>
              </div>
            </div>
            <div class="conMain">
              <ul class="newsList">
                <li
                  class="clearfix"
                  v-for="(item, cindex) in list"
                  :key="cindex"
                >
                  <a
                    @click="gotodetails(item.id)"
                    :title="item.title"
                    v-if="item.id != 5285"
                    >{{ item.title }}</a
                  >
                  <span v-if="item.id != 5285">{{ item.date }}</span>
                </li>
                <div v-if="emailBox ==5663" v-html="emailBoxHtml" class="emailBoxNth">{{emailBoxHtml}}</div>
                <img v-if="zzjgImageAid == 5285" :src="AidimageUrl" alt="" />
                <img v-if="zzjgImageAid == 5238" :src="AidimageUrl" alt="" />
                <img v-if="zzjgImageAid == 6181" :src="AidimageUrl" alt="" />
              </ul>
              <div class="pageNum">
                <div class="page">
                  <el-pagination
                    background
                    @size-change="pagesize"
                    @current-change="handleSizeChange"
                    :page-size="pagesize"
                    :hide-on-single-page="pageTotalValue"
                    layout="total, prev, pager, next,jumper"
                    :total="total"
                    :pager-count="5"
                  ></el-pagination>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--main End!-->
  </div>
</template>
<script>
import { GET_INDEX_LIST } from "@/api/index.js";
import { mapMutations, mapGetters, mapState } from "vuex";
export default {
  name: "news",
  data() {
    return {
      total: null, //数据总数
      pagesize: 10, //  每页的数据
      loading: false,
      list: [], //数据请求过来的数据
      DepsData: {}, //Vuex里面的数据
      newClassId: "", //选中是的样式id
      docTitle: "", //选中时的页面title,
      spanTitle: "", //选中右边提示
      nameTitle: "", //选中的页面名称
      zzjgImageAid: "", //系组织结构的id
      AidimageUrl: "", //系组织结构的图片路径
      pageTotalValue: false, //栏目页面的总数
      emailBox:"", //领导邮箱id
      emailBoxHtml:""
    };
  },
  beforeCreate(){
  },
  created() {
    this.getDataList();
  },
  computed: {
    ...mapGetters(["id", "cid", "DepsDatas", "sid", "clickCid", "detailTitle"]),
    ...mapState(["DepsDat", "moblie"]),
  },
  mounted() {
    var title = document.title;
    this.DepsDat.map((item, index) => {
      for (var i = 0; i < item.children.length; i++) {
        if (item.children[i].title == title) {
          var data = {
            a: index,
            b: i,
          };
          this.SET_CLICKCID(data);
        }
      }
    });
  },
  methods: {
    ...mapMutations({
      SET_LISTCID: "SET_LISTCID",
      SET_DETAILSNAME: "SET_DETAILSNAME",
      SET_CLICKCID: "SET_CLICKCID",
      SET_SEARCHTEXT: "SET_SEARCHTEXT",
    }),
    // 点击跳转到首页
    gotoindex() {
      console.log(document.title);
      if(document.title =='404错误提示'){
        this.$router.push({ name: "index" });
      }else{
        this.$router.push({ name: "index" });
      }
    },
    // 点击改变页面的子栏目
    gotonav(index, cindex) {
      // 同下getDataList的方法一样
      this.newClassId = index.cid;
      this.docTitle = index.title;
      this.spanTitle = index.spanTitle;
      let data = {
        a: this.clickCid.a,
        b: cindex,
      };
      this.SET_CLICKCID(data);
      this.SET_DETAILSNAME(this.spanTitle);
      this.$router.push({ path: `/${index.picName}.htm` });
    },
    getDataList() {
      this.SET_SEARCHTEXT("");
      //   栏目页的DepsDat数据下标（一级）
      this.DepsData = this.DepsDat[this.clickCid.a];
      //  获取二级下标下面的cid赋值给newClassId
      this.newClassId = this.DepsData.children[this.clickCid.b].cid;
      //   获取二级下标下面的spanTitle赋值给spanTitle
      this.spanTitle = this.DepsData.children[this.clickCid.b].spanTitle;
      // 页面title等于二级下标下面的title
      document.title = this.DepsData.children[this.clickCid.b].title;
      //   获取二级下标下面的name赋值给nameTitle--选中的页面名称
      this.nameTitle = this.DepsData.children[this.clickCid.b].name;
      // document.documentElement.clientHeight = '50px'
      //   发送对应的网络请求
      this.getListIndex();
    },
    gotodetails(index) {
      if (this.moblie) {
        // 点击页面跳转延迟500毫秒
        setTimeout(() => {
          let routeData = this.$router.resolve({
            path: `/info/${this.newClassId}/${index}.htm`,
          });
          window.open(routeData.href, "_blank");
        }, 300);
      } else {
        this.$router.push({
          path: `/info/${this.newClassId}/${index}.htm`,
        });
      }
    },
    // 分页的方法
    handleSizeChange: function (size) {
      this.loading = true
      this.list = [];
      this.zzjgImageAid = "";
      let data = {
        t: "n",
        sid: this.sid,
        pid: this.newClassId,
        cid: this.newClassId,
        pi: size,
        ps: "10",
      };
      GET_INDEX_LIST(data).then((res) => {
        this.loading = false
        this.list = []
        res.data.map((item) => {
            this.list.push(item);
        });
        if (res.request.rc > 10) {
          this.total = res.request.rc;
          this.pageTotalValue = false;
        } else {
          this.pageTotalValue = true;
        }
      });
    },
    // 正式发送栏目的网络请求
    getListIndex() {
      this.list = [];
      this.loading = true
      this.zzjgImageAid = "";
      let data = {
        t: "n",
        sid: this.sid,
        pid: this.newClassId,
        cid: this.newClassId,
        pi: 1,
        ps: 10,
      };
      GET_INDEX_LIST(data).then((res) => {
        this.list = []
        this.loading = false
        this.emailBox = ''
        // 图片路径
        res.data.map((item) => {
          if (item.id == 5285) {
            this.zzjgImageAid = item.id;
            this.getZzjgAid();
          } else if (item.id == 5238) {
            this.zzjgImageAid = item.id;
            this.getZzjgAid();
          }else if (item.id == 6181) {
            this.zzjgImageAid = item.id;
            this.getZzjgAid();
          }else if(item.id ==5663){
            this.emailBox = item.id
            this.getEmailBox()
            return
          }else{
            this.list.push(item);
          }
        });
        if (res.request.rc > 10) {
          this.total = res.request.rc;
          this.pageTotalValue = false;
        } else {
          this.total = 0;
          this.pageTotalValue = true;
        }
      });
    },
    // 获取详情数据
    getEmailBox() {
      let data = {
        t: "a",
        sid: this.sid,
        af: "abcomlkn",
        aid: this.emailBox,
      };
      GET_INDEX_LIST(data).then((res) => {
        this.emailBoxHtml = res.data.content
      });
    },
    // 获取图片数据
    getZzjgAid() {
      let data = {
        t: "a",
        sid: this.sid,
        af: "abcy",
        aid: this.zzjgImageAid,
      };
      GET_INDEX_LIST(data).then((res) => {
        this.AidimageUrl = res.data.files[0].path;
      });
    },
  },
  watch: {
    //   监听Vuex里面的clickCid的是否发生变化
    clickCid() {
      document.title = this.docTitle;
      this.getDataList();
    },
  },
};
</script>
<style  scoped>
#main >>> .el-pagination {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  white-space: nowrap;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
}
#main >>> .el-pager {
  display: flex;
  flex-wrap: wrap;
}
img {
  width: 96%;
}
@import url(../../assets/css/style.css);
@import url(../../assets/css/index.css);
</style>